import bugsnag from '@bugsnag/js';
import config from './config';

export default bugsnag({
  apiKey: config.bugsnagAPIKey,
  releaseStage: config.bugsnagReleaseStage,
  notifyReleaseStages: ['production'],
  appVersion: config.appVersion,
});
